module.exports = __webpack_public_path__ + "img/casey_house_logo.6331a256.svg";